var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 3V17.6528C14.5139 17.1806 13.5694 16.8889 12.5556 16.8889C9.48611 16.8889 7 19.375 7 22.4444C7 25.5139 9.48611 28 12.5556 28C15.625 28 18.1111 25.5139 18.1111 22.4444V8.55556H23.6667V3H15.3333ZM12.5556 25.2222C11.0278 25.2222 9.77778 23.9722 9.77778 22.4444C9.77778 20.9167 11.0278 19.6667 12.5556 19.6667C14.0833 19.6667 15.3333 20.9167 15.3333 22.4444C15.3333 23.9722 14.0833 25.2222 12.5556 25.2222Z",
    fill: "#FF9C1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAudio);
export default __webpack_public_path__ + "static/media/DownloadAudio.d7f25cc33926e84362f30edc3bc2de24.svg";
export { ForwardRef as ReactComponent };